import { LoadingState } from '@/dto/enums/LoadingState'
import { Item } from '@/dto/Item'

// State represents the Data behind a Item-Feed-View.
export class FeedState {
  loadingState: LoadingState = LoadingState.Initial
  items: Item[] = []
}
